import routeManager from "@/router/route-manager";

/**
 * Whether the current location should highlight a sidebar link to `linkPath`.
 * Home is matched exactly; other paths match exact or as a prefix for nested routes.
 */
export function isSidebarLinkActive(currentPath: string, linkPath: string): boolean {
  if (!linkPath) {
    return false;
  }
  if (routeManager.isHomePath(linkPath)) {
    return routeManager.isHomePath(currentPath);
  }
  const normalize = (p: string) => {
    let s = p.toLowerCase();
    if (s.length > 1 && s.endsWith("/")) {
      s = s.slice(0, -1);
    }
    return s;
  };
  const c = normalize(currentPath);
  const t = normalize(linkPath);
  return c === t || c.startsWith(`${t}/`);
}
